<template>
    <div class="solution-page">
        <NavBar />
        <main>
            <section class="product-hero">
                <b-container><b-row class="align-items-center">
                        <b-col lg="7"><span class="eyebrow">{{ solution.eyebrow }}</span>
                            <h1>{{ solution.title }}</h1>
                            <p>{{ solution.lead }}</p>
                            <div class="actions"><a :href="whatsappUrl" target="_blank" rel="noopener">Solicitar
                                    diagnóstico <b-icon icon="arrow-up-right" /></a><a href="#capacidades">Ver
                                    capacidades <b-icon icon="arrow-down" /></a></div>
                        </b-col>
                        <b-col lg="5">
                            <figure v-if="solution.heroImage" class="product-image">
                                <img :src="solution.heroImage" :alt="solution.heroImageAlt">
                            </figure>
                            <div v-else class="product-diagram"><span>{{ solution.diagram.top }}</span>
                                <div class="diagram-core"><b-icon :icon="solution.icon" /><strong>{{
                                        solution.diagram.core }}</strong></div>
                                <div class="diagram-flow"><i></i><i></i><i></i></div><small>{{ solution.diagram.bottom
                                    }}</small>
                            </div>
                        </b-col>
                    </b-row></b-container>
            </section>

            <section class="value-strip"><b-container>
                    <div v-for="item in solution.value" :key="item.title"><strong>{{ item.title }}</strong><span>{{
                            item.text }}</span></div>
                </b-container></section>

            <section id="capacidades" class="page-section"><b-container>
                    <header><span>CAPACIDADES</span>
                        <h2>{{ solution.capabilityTitle }}</h2>
                        <p>{{ solution.capabilityLead }}</p>
                    </header>
                    <div class="capability-grid">
                        <article v-for="(item, index) in solution.capabilities" :key="item.title"><small>0{{ index + 1
                                }}</small><b-icon :icon="item.icon" />
                            <h3>{{ item.title }}</h3>
                            <p>{{ item.text }}</p>
                        </article>
                    </div>
                </b-container></section>

            <section v-if="solution.result" class="impact"><b-container>
                    <div class="impact-number">{{ solution.result.number }}<small>%</small></div>
                    <div><span>RESULTADO EN PROYECTO</span>
                        <h2>{{ solution.result.title }}</h2>
                        <p>{{ solution.result.text }}</p><small>El impacto puede variar según la operación y alcance de
                            cada empresa.</small>
                    </div>
                </b-container></section>

            <section class="page-section fit"><b-container><b-row><b-col lg="5"><span class="section-tag">PARA TU
                                OPERACIÓN</span>
                            <h2>{{ solution.fitTitle }}</h2>
                        </b-col><b-col lg="7">
                            <ul>
                                <li v-for="item in solution.fit" :key="item"><b-icon icon="check2" />{{ item }}</li>
                            </ul>
                        </b-col></b-row></b-container></section>

            <section class="page-section faq"><b-container><b-row><b-col lg="4"><span class="section-tag">PREGUNTAS
                                FRECUENTES</span>
                            <h2>Lo que necesitas saber</h2>
                        </b-col><b-col lg="8">
                            <details v-for="(item, index) in solution.faqs" :key="item.question" :open="index === 0">
                                <summary>{{ item.question }}<b-icon icon="plus" /></summary>
                                <p>{{ item.answer }}</p>
                            </details>
                        </b-col></b-row></b-container></section>

            <section class="cta"><b-container>
                    <div>
                        <section><span>SIGUIENTE PASO</span>
                            <h2>{{ solution.cta }}</h2>
                            <p>Agenda una conversación con un especialista para revisar tu proceso actual.</p>
                        </section><a :href="whatsappUrl" target="_blank" rel="noopener">Hablar por WhatsApp <b-icon
                                icon="whatsapp" /></a>
                    </div>
                </b-container></section>
        </main>
        <FooterChillByte />
    </div>
</template>

<script>
import NavBar from "../components/Template/NavBar.vue";
import Footer from "../components/Template/Footer.vue";

const SITE_URL = "https://www.chillbytesolutions.com";
const solutions = {
    pos: {
        slug: "pos-netsuite", icon: "shop", eyebrow: "PUNTO DE VENTA CONECTADO A NETSUITE", title: "Vende en sucursal sin perder el control de tu ERP", lead: "Korventa es un POS conectado a Oracle NetSuite para mantener ventas, clientes, productos e información operativa dentro de un mismo ecosistema.",
        heroImage: require("../assets/img/soluciones/Korventa POS Logo.png"),
        heroImageAlt: "Korventa Retail POS conectado a Oracle NetSuite",
        value: [{ title: "Una sola fuente", text: "Datos conectados con NetSuite" }, { title: "Operación ágil", text: "Flujo diseñado para punto de venta" }, { title: "Escalable", text: "Preparado para múltiples sucursales" }],
        capabilityTitle: "Conecta el piso de venta con la gestión empresarial", capabilityLead: "Diseñamos el flujo de integración de acuerdo con la configuración, controles y volumen de tu cuenta NetSuite.",
        capabilities: [{ icon: "receipt", title: "Ventas conectadas", text: "Korventa Sync envía la información comercial necesaria hacia NetSuite con trazabilidad automáticamente." }, { icon: "people", title: "Clientes", text: "Consulta o registra clientes evitando capturas aisladas entre sistemas." }, { icon: "box", title: "Productos e inventario", text: "Mantén disponible la información que el equipo necesita para vender." }, { icon: "diagram-3", title: "Integración adaptable", text: "Definimos frecuencia, reglas y manejo de excepciones para tu operación." },{ icon: "eye", title: "Monitoreo de la Integración", text: "En Korventa Hub podrás monitorear la salud de la integración de todas las tiendas, conceder accesos por sucursal o retirar accesos." },{ icon: "download", title: "Reportes Descargables", text: "En Korventa Hub podrás descargar reportes de los artículos más vendidos por sucursal, reportes de cortes de caja y mucho más." }],
        fitTitle: "Ideal para empresas que necesitan", fit: ["Operar sucursales con una experiencia de venta rápida", "Reducir recapturas entre el POS y NetSuite", "Centralizar información comercial para análisis y control", "Adaptar el punto de venta a procesos propios"],
        faqs: [{ question: "¿El POS reemplaza a NetSuite?", answer: "No. El POS facilita la operación de venta y se conecta con NetSuite como sistema central, de acuerdo con la arquitectura definida para cada empresa." }, { question: "¿Puede adaptarse a nuestras sucursales?", answer: "Sí. Se analiza el flujo de venta, catálogos, permisos, conectividad y reglas necesarias antes de definir el alcance." }, { question: "¿La sincronización es en tiempo real?", answer: "Puede diseñarse en tiempo real o por lotes según el proceso, volumen, APIs disponibles y nivel de continuidad requerido." }], cta: "Lleva tu operación de venta al ecosistema NetSuite", metaTitle: "POS conectado a Oracle NetSuite en México | Chill Byte", metaDescription: "Punto de venta conectado a Oracle NetSuite para sincronizar ventas, clientes, productos e información operativa de sucursales."
    },
    bank: {
        slug: "conciliador-bancario-netsuite", icon: "bank", eyebrow: "CONCILIACIÓN BANCARIA PARA NETSUITE", title: "Conciliaciones más rápidas. Diferencias bajo control.", lead: "Automatiza el cruce de movimientos bancarios y transacciones en NetSuite para que tu equipo financiero deje la comparación manual y trabaje por excepción.",
        diagram: { top: "CONTROL FINANCIERO", core: "Banco + NetSuite", bottom: "CRUCE · REGLAS · EXCEPCIONES" },
        value: [{ title: "Menos captura", text: "Automatiza tareas repetitivas" }, { title: "Más visibilidad", text: "Identifica partidas pendientes" }, { title: "Trazabilidad", text: "Conserva evidencia del proceso" }],
        capabilityTitle: "Convierte archivos y movimientos en información conciliable", capabilityLead: "Las reglas se configuran alrededor de tus bancos, referencias, transacciones y criterios financieros.",
        capabilities: [{ icon: "file-earmark-arrow-up", title: "Carga de movimientos", text: "Incorpora información bancaria en formatos definidos para el proceso." }, { icon: "intersect", title: "Cruce automático", text: "Compara importes, fechas, referencias y otros criterios configurables por banco." }, { icon: "exclamation-square", title: "Gestión de excepciones", text: "Separa diferencias para revisión sin detener las coincidencias válidas." }, { icon: "clipboard-data", title: "Seguimiento", text: "Consulta estatus, partidas pendientes y evidencia de conciliación." },{ icon: "file-spreadsheet", title: "Reportes más detallados", text: "Podrás generar reportes más detallados donde se muestre la(s) línea(s) de estado de cuenta vs. la transacción en NetSuite." }],
        fitTitle: "Ideal para equipos financieros que buscan", fit: ["Reducir conciliaciones manuales en hojas de cálculo", "Aplicar criterios consistentes entre cuentas y bancos", "Detectar diferencias y partidas no identificadas con rapidez", "Mantener trazabilidad del proceso financiero"],
        faqs: [{ question: "¿Funciona con cualquier banco?", answer: "Sí, la compatibilidad depende del formato del estado de cuenta ya sea CSV o TXT. Durante el diagnóstico revisamos bancos, cuentas y archivos para definir conectores y reglas." }, { question: "¿El conciliador registra información en NetSuite?", answer: "El alcance puede incluir consulta y registro según la arquitectura, permisos y controles acordados para la cuenta." }, { question: "¿Puede manejar reglas diferentes por cuenta?", answer: "Sí. Las reglas pueden configurarse para considerar referencias, fechas, tolerancias y otros criterios del proceso." }], cta: "Deja que tu equipo financiero trabaje por excepción", metaTitle: "Conciliador Bancario para Oracle NetSuite | Chill Byte", metaDescription: "Conciliador bancario conectado a Oracle NetSuite para automatizar cruces, gestionar excepciones y reducir trabajo manual financiero."
    },
    fiscal: {
        slug: "soluciones-fiscales-netsuite", icon: "file-earmark-check", eyebrow: "SOLUCIONES FISCALES NETSUITE MÉXICO", title: "Cumplimiento fiscal conectado con tu operación NetSuite", lead: "Valida, timbra y controla documentos fiscales de México sin crear procesos paralelos ni perder trazabilidad dentro del ERP.",
        diagram: { top: "CUMPLIMIENTO MÉXICO", core: "SAT + NetSuite", bottom: "CFDI · XML · PROVEEDORES" },
        value: [{ title: "60% menos", text: "trabajo manual en un caso financiero" }, { title: "Validación", text: "Reglas fiscales y de negocio" }, { title: "Trazabilidad", text: "Documentos vinculados al ERP" }],
        capabilityTitle: "Un ecosistema fiscal diseñado para México", capabilityLead: "Integramos capacidades fiscales con NetSuite para reducir captura, errores y puntos ciegos.",
        capabilities: [{ icon: "file-earmark-code", title: "Validador XML", text: "Verifica estructura, vigencia, datos fiscales y reglas del negocio." }, { icon: "people", title: "Portal de Proveedores", text: "Recibe documentos y da seguimiento al proceso desde un canal controlado." }, { icon: "box", title: "Pedimentos", text: "Obtén trazabilidad desde que entra un pedimento a tu almacén hasta su salida. Asignación en automático en línea de transacción listo para timbrado." }, { icon: "receipt", title: "CFDI y complementos", text: "Timbrado, cancelación, addendas y complementos fiscales." }, { icon: "truck", title: "Comercio Exterior", text: "Carta Porte, pedimentos y trazabilidad vinculada con facturas." }, { icon: "journal-check", title: "Contabilidad electrónica", text: "Genera y organiza información necesaria para obligaciones aplicables." }, { icon: "diagram-3", title: "Integración NetSuite", text: "Consulta y registra información según la arquitectura de tu cuenta." }],
        result: { number: "60", title: "menos trabajo manual para el área financiera", text: "Resultado obtenido con un Validador XML y Portal de Proveedores en una operación de cliente." },
        fitTitle: "Ideal para empresas que necesitan", fit: ["Validar CFDI recibidos antes de procesarlos", "Ordenar la recepción documental de proveedores", "Automatizar timbrado, complementos, addendas y cancelaciones", "Controlar Carta Porte, comercio exterior y pedimentos", "Mantener trazabilidad fiscal dentro de NetSuite"],
        faqs: [{ question: "¿Qué valida la solución de XML?", answer: "Puede validar estructura, estatus ante el SAT, datos fiscales y reglas adicionales del proceso de cada empresa." }, { question: "¿El Portal de Proveedores se conecta con NetSuite?", answer: "Sí. La integración se diseña para consultar o registrar la información acordada, respetando controles y permisos de la cuenta." }, { question: "¿Incluye Carta Porte y Comercio Exterior?", answer: "Sí. El portafolio contempla Carta Porte, complemento de Comercio Exterior y trazabilidad de pedimentos, además de otras capacidades CFDI." }, { question: "¿Sustituye la asesoría fiscal?", answer: "No. La solución automatiza procesos tecnológicos y controles configurados; las decisiones fiscales deben validarse con los asesores responsables de cada empresa." },{ question: "¿Se puede desarrollar soluciones fiscales de otros países?", answer: "Sí, se pueden desarrollar módulos fiscales para otros países que no sean México. Se realiza un levantamiento con el área fiscal y contable de la empresa para definir alcance y funcionalidades clave para que su empresa cumpla con las normas fiscales del país." }], cta: "Reduce carga operativa sin perder cumplimiento", metaTitle: "Soluciones fiscales para Oracle NetSuite México | Chill Byte", metaDescription: "Validador XML, Portal de Proveedores, CFDI, addendas, cancelación, Carta Porte, Comercio Exterior y contabilidad electrónica para NetSuite."
    }
};

export default {
    name: "NetSuiteSolutionView", components: { NavBar, FooterChillByte: Footer }, props: { solutionKey: { type: String, required: true } },
    computed: { solution() { return solutions[this.solutionKey]; }, whatsappUrl() { return `https://api.whatsapp.com/send?phone=4423336440&text=${encodeURIComponent(`Hola, quiero información sobre ${this.solution.title}`)}`; } },
    metaInfo() { const canonical = `${SITE_URL}/${this.solution.slug}`; const service = { "@context": "https://schema.org", "@type": "Service", name: this.solution.title, description: this.solution.metaDescription, areaServed: "MX", provider: { "@type": "Organization", name: "Chill Byte Solutions", url: SITE_URL }, url: canonical }; const faq = { "@context": "https://schema.org", "@type": "FAQPage", mainEntity: this.solution.faqs.map(item => ({ "@type": "Question", name: item.question, acceptedAnswer: { "@type": "Answer", text: item.answer } })) }; return { title: this.solution.metaTitle, link: [{ rel: "canonical", href: canonical }], meta: [{ vmid: "description", name: "description", content: this.solution.metaDescription }, { vmid: "robots", name: "robots", content: "index,follow,max-image-preview:large,max-snippet:-1" }, { vmid: "og:title", property: "og:title", content: this.solution.metaTitle }, { vmid: "og:description", property: "og:description", content: this.solution.metaDescription }, { vmid: "og:url", property: "og:url", content: canonical }, { vmid: "twitter:card", name: "twitter:card", content: "summary_large_image" }], script: [{ vmid: "solution-service", type: "application/ld+json", innerHTML: JSON.stringify(service) }, { vmid: "solution-faq", type: "application/ld+json", innerHTML: JSON.stringify(faq) }], __dangerouslyDisableSanitizersByTagID: { "solution-service": ["innerHTML"], "solution-faq": ["innerHTML"] } }; }
};
</script>

<style scoped lang="scss">
$ink: #101828;
$muted: #475467;
$line: #dbe3ee;
$blue: #146ef5;
$surface: #f4f7fb;

.solution-page {
    color: $ink;
    letter-spacing: 0
}

.product-hero {
    position: relative;
    overflow: hidden;
    padding: 105px 0;
    background: #f7f9fc;
    border-bottom: 1px solid $line
}

.product-hero:before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: linear-gradient(rgba(20, 110, 245, .05) 1px, transparent 1px), linear-gradient(90deg, rgba(20, 110, 245, .05) 1px, transparent 1px);
    background-size: 48px 48px;
    mask-image: linear-gradient(to right, #000, transparent 75%)
}

.product-hero .container {
    position: relative
}

.eyebrow,
.section-tag,
.page-section header>span {
    display: block;
    color: #075fcf;
    font-size: .75rem;
    font-weight: 800;
    letter-spacing: .12em;
    margin-bottom: 18px
}

.product-hero h1 {
    max-width: 780px;
    color: $ink !important;
    font-size: clamp(3rem, 5vw, 4.6rem) !important;
    font-weight: 800;
    line-height: 1;
    margin: 0 0 25px
}

.product-hero p {
    max-width: 720px;
    color: $muted;
    font-size: 1.18rem;
    line-height: 1.7
}

.actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 30px
}

.actions a,
.cta a {
    min-height: 52px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 13px 22px;
    border-radius: 6px;
    font-weight: 800
}

.actions a:first-child {
    color: #fff;
    background: $blue
}

.actions a:last-child {
    color: $ink;
    background: #fff;
    border: 1px solid #cbd5e1
}

.actions a:hover,
.cta a:hover {
    text-decoration: none
}

.product-diagram {
    position: relative;
    height: 340px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center
}

.product-image {
    width: 100%;
    max-width: 430px;
    min-height: 340px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 34px;
    background: #fff;
    border: 1px solid #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 22px 60px rgba(16, 24, 40, .14)
}

.product-image img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 285px;
    object-fit: contain
}

.product-diagram>span,
.product-diagram>small {
    color: #667085;
    font-size: .7rem;
    font-weight: 800;
    letter-spacing: .12em
}

.diagram-core {
    width: 220px;
    height: 140px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin: 28px 0 18px;
    background: #fff;
    border: 1px solid #99bff8;
    border-radius: 8px;
    box-shadow: 0 22px 60px rgba(16, 24, 40, .14)
}

.diagram-core svg {
    width: 35px;
    height: 35px;
    color: $blue
}

.diagram-flow {
    display: flex;
    gap: 16px;
    margin-bottom: 20px
}

.diagram-flow i {
    width: 45px;
    border-top: 2px solid $blue
}

.value-strip {
    background: #fff;
    border-bottom: 1px solid $line
}

.value-strip .container {
    display: grid;
    grid-template-columns: repeat(3, 1fr)
}

.value-strip .container>div {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 25px;
    border-right: 1px solid $line
}

.value-strip .container>div:first-child {
    border-left: 1px solid $line
}

.value-strip span {
    color: $muted;
    font-size: .85rem
}

.page-section {
    padding: 100px 0
}

.page-section header {
    max-width: 720px;
    margin-bottom: 50px
}

.page-section h2,
.fit h2,
.faq h2,
.impact h2 {
    color: $ink;
    font-size: clamp(2.15rem, 4vw, 3.2rem);
    font-weight: 800;
    line-height: 1.08
}

.page-section header p {
    color: $muted;
    font-size: 1.05rem;
    line-height: 1.7
}

.capability-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    border-top: 1px solid $line;
    border-left: 1px solid $line
}

.capability-grid article {
    position: relative;
    min-height: 270px;
    padding: 28px;
    border-right: 1px solid $line;
    border-bottom: 1px solid $line
}

.capability-grid article>small {
    position: absolute;
    right: 20px;
    color: #98a2b3
}

.capability-grid svg {
    width: 28px;
    height: 28px;
    color: $blue;
    margin: 8px 0 36px
}

.capability-grid h3 {
    font-size: 1.15rem;
    font-weight: 800
}

.capability-grid p {
    color: $muted;
    line-height: 1.6
}

.impact {
    padding: 80px 0;
    color: #fff;
    background: #0c1b33
}

.impact .container {
    display: grid;
    grid-template-columns: .35fr .65fr;
    align-items: center;
    gap: 60px
}

.impact-number {
    color: #67d6ea;
    font-size: 7rem;
    font-weight: 800;
    line-height: 1
}

.impact-number small {
    font-size: 3rem
}

.impact span {
    color: #67d6ea;
    font-size: .72rem;
    font-weight: 800;
    letter-spacing: .12em
}

.impact h2 {
    color: #fff;
    margin: 10px 0
}

.impact p {
    color: #c3ccda;
    font-size: 1.05rem
}

.impact div>small {
    color: #8191aa
}

.fit {
    background: $surface
}

.fit ul {
    list-style: none;
    padding: 0;
    margin: 0
}

.fit li {
    display: flex;
    gap: 14px;
    padding: 18px 0;
    color: #344054;
    border-bottom: 1px solid #d0d5dd;
    font-weight: 650
}

.fit li svg {
    color: $blue;
    flex: 0 0 auto
}

.faq details {
    border-top: 1px solid #cbd5e1
}

.faq details:last-child {
    border-bottom: 1px solid #cbd5e1
}

.faq summary {
    display: flex;
    justify-content: space-between;
    padding: 23px 4px;
    font-weight: 800;
    cursor: pointer;
    list-style: none
}

.faq details p {
    color: $muted;
    line-height: 1.7;
    padding: 0 45px 23px 4px
}

.faq details[open] summary svg {
    transform: rotate(45deg)
}

.cta {
    padding: 70px 0;
    color: #fff;
    background: $blue
}

.cta .container>div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 35px
}

.cta section {
    max-width: 750px
}

.cta section>span {
    font-size: .72rem;
    font-weight: 800;
    letter-spacing: .12em
}

.cta h2 {
    color: #fff;
    font-size: clamp(2rem, 4vw, 3rem);
    font-weight: 800;
    margin: 10px 0
}

.cta p {
    color: rgba(255, 255, 255, .85)
}

.cta a {
    flex: 0 0 auto;
    color: #073b8c;
    background: #fff
}

@media(max-width:991px) {
    .product-diagram,
    .product-image {
        margin-top: 50px
    }

    .capability-grid {
        grid-template-columns: repeat(2, 1fr)
    }

    .cta .container>div {
        align-items: flex-start;
        flex-direction: column
    }
}

@media(max-width:575px) {
    .product-hero {
        padding: 70px 0
    }

    .product-hero h1 {
        font-size: 2.7rem !important
    }

    .actions {
        flex-direction: column
    }

    .actions a {
        justify-content: center
    }

    .value-strip .container,
    .capability-grid,
    .impact .container {
        grid-template-columns: 1fr
    }

    .value-strip .container>div {
        border-left: 1px solid $line
    }

    .page-section {
        padding: 65px 0
    }

    .capability-grid article {
        min-height: 220px
    }

    .impact {
        padding: 65px 0
    }

    .impact-number {
        font-size: 5rem
    }

    .cta {
        padding: 55px 0
    }

    .cta a {
        width: 100%;
        justify-content: center
    }
}
</style>